import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx";

export const useCatalogSelectedFilters = () => {
    const {catalogStore} = useStoreMobx();
    const deleteFilter = catalogStore.deleteFilter;

    const resetAllFilters = catalogStore.resetAllFilters;

    return {
        deleteFilter,
        resetAllFilters,
    };
};
